<template>
  <div>
    <!-- <pole-star-module></pole-star-module> -->
    <pole-star-article></pole-star-article>
  </div>
</template>

<script>
import store from '@/store';
import PoleStarArticle from '@/components/widgets/PoleStarArticle';
import { mapGetters } from 'vuex';

export default {
  name: 'PoleStarArticleParent',
  data () {
    return {};
  },
  components: {
    PoleStarArticle
  },
  computed: mapGetters({
    help: 'help'
  }),
  created: function () {},
  mounted () {},
  methods: {},
  watch: {}
};

</script>

<style type="text/css"></style>

